export default "__VITE_ASSET__CYsj0M14__"